import styled from 'styled-components';
import { GhostButton } from 'ui/button';
import { InfoFill } from 'ui/icons';
import { WorkflowsEmptyState } from 'ui/illustrations';
import { Link } from 'ui/links';
import { body2, colors, fontSizes, fontWeights, link, spacing } from 'ui/theme';

import { WORKFLOWS_KNOWLEDGE_BASE_URL } from '../constants';

const displayText = {
  headline: "You'll find your journeys here",
  captionPrefix: 'To send your contacts personalized messages based on their interactions',
  addWorkflow: 'add a new journey',
  learnMore: 'Learn more about',
  journeys: 'journeys',
};

const Container = styled.div`
  width: 100%;
  position: relative;
  padding: ${spacing.x12} 0;
`;

const Message = styled.div`
  width: ${spacing.x32};
  margin: 0 auto;
  text-align: center;
`;

const Headline = styled.p`
  font-size: ${fontSizes.s20};
  margin: ${spacing.half} 0 0 0;
  color: ${colors.textPrimary};
  font-weight: ${fontWeights.bold};
`;

const Caption = styled.p`
  font-size: ${fontSizes.s16};
  margin: ${spacing.half} 0 0 0;
  color: ${colors.textSecondary};
`;

const Footnote = styled.p`
  ${body2}
  margin: 0;
  color: ${colors.textSecondary};
  text-align: center;
`;

const LinkButton = styled(GhostButton)`
  && {
    padding: 0;
    margin: 0;
    display: inline;
    height: auto;
    ${link};

    &:hover {
      background-color: transparent;
    }
  }
`;

const InfoIcon = styled(InfoFill)`
  color: ${colors.cyan100};
  margin-right: ${spacing.eighth};
`;

type WorkflowsGuideMessageProps = {
  onCreateWorkflowButtonClick: () => void;
};

export const EmptyStateMessage = ({ onCreateWorkflowButtonClick }: WorkflowsGuideMessageProps) => (
  <>
    <Container data-test="workflows-index-empty-state-message">
      <Message>
        <WorkflowsEmptyState />
        <Headline>{displayText.headline}</Headline>
        <Caption>
          {displayText.captionPrefix},{' '}
          <LinkButton onClick={onCreateWorkflowButtonClick}>{displayText.addWorkflow}</LinkButton>.
        </Caption>
      </Message>
    </Container>
    <Footnote>
      <InfoIcon isColorInherited={true} /> {displayText.learnMore}{' '}
      <Link hasOpenNewTabIcon href={WORKFLOWS_KNOWLEDGE_BASE_URL} target="_blank">
        {displayText.journeys}
      </Link>
    </Footnote>
  </>
);
